import { c as _c } from "react/compiler-runtime";
import { type FocusEvent, useEffect, useState } from 'react';
import { nodeKeyError } from '../store/field-key';
import { useBuilder } from '../store/provider';
import { nodesEqual } from '../store/reducer';
import { nodeToWire } from '../store/wire';
export const useNodeSave = nodeId => {
  const $ = _c(15);
  const {
    state,
    mutateOp
  } = useBuilder();
  const [savePending, setSavePending] = useState(false);
  let t0;
  if ($[0] !== mutateOp || $[1] !== nodeId || $[2] !== savePending || $[3] !== state.bundle || $[4] !== state.current?.isHistoricalPreview || $[5] !== state.savedBundle) {
    t0 = () => {
      if (!savePending) {
        return;
      }
      setSavePending(false);
      if (state.current?.isHistoricalPreview || !state.savedBundle) {
        return;
      }
      const node = state.bundle.nodes.find(candidate => candidate.id === nodeId);
      if (!node) {
        return;
      }
      const saved = state.savedBundle.nodes.find(candidate_0 => candidate_0.id === nodeId);
      if (nodesEqual(node, saved) || nodeKeyError(node)) {
        return;
      }
      mutateOp({
        kind: "update_node",
        node: nodeToWire(node)
      });
    };
    $[0] = mutateOp;
    $[1] = nodeId;
    $[2] = savePending;
    $[3] = state.bundle;
    $[4] = state.current?.isHistoricalPreview;
    $[5] = state.savedBundle;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  const t1 = state.current?.isHistoricalPreview;
  let t2;
  if ($[7] !== mutateOp || $[8] !== nodeId || $[9] !== savePending || $[10] !== state.bundle || $[11] !== state.savedBundle || $[12] !== t1) {
    t2 = [savePending, t1, state.bundle, state.savedBundle, nodeId, mutateOp];
    $[7] = mutateOp;
    $[8] = nodeId;
    $[9] = savePending;
    $[10] = state.bundle;
    $[11] = state.savedBundle;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  useEffect(t0, t2);
  let t3;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e => {
      if (e.currentTarget.contains(e.relatedTarget as Node)) {
        return;
      }
      setSavePending(true);
    };
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};